// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3c_9g","alert":"SettungsInbox_alert__Kz3-t"};